import { pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { PRODUCT_GALLERY_MEDIA_RADIUS_PX } from './ProductGallery.style';

/** Match ImageSlide tile corners so video slides align with image tiles in the gallery. */
export const VideoContainer: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.primitive.black,
    width: '100%',
    height: '100%',
    borderRadius: pxToRem(PRODUCT_GALLERY_MEDIA_RADIUS_PX),
    overflow: 'hidden',
    clipPath: `inset(0 round ${pxToRem(PRODUCT_GALLERY_MEDIA_RADIUS_PX)})`,
});

export const VideoPlayer: StyleRule = () => ({
    width: '100%',
    height: '100%',
});
